import {useEffect, useRef, useState} from 'react';
import {Navigate, NavLink, useLocation, useNavigate} from 'react-router-dom';
import styled from 'styled-components';
import {Button} from '@/components/Button';
import {NavBar} from '@/components/NavBar';
import {Splash} from '@/components/Splash';
import {Typography} from '@/components/Typography';
import {
  Body, FormWrapper as FormWrapperBase, Title as TitleBase
} from '@/components/UserSession/StyledComponents';
import {useSession} from '@/hooks';
import {paths} from '@/router';
import {FlexFullGrow, HorizontalFullContainer} from '@/styled-components';
import {palette} from '@/styles';
import DoneImage from './done.gif';

const Welcome = () => {
  const navigate = useNavigate();
  const [remainTime, setRemainTime] = useState<number>(5);
  const timer = useRef<NodeJS.Timer>();
  const {hasSession, isPending, isRefetching} = useSession();
  const {pathname, search, state} = useLocation();
  // join 직후 navigate 시 me 재요청 완료 전에 !hasSession 분기로 signin 리다이렉트되는 것을 방지
  const fromJoin = !!(state as {fromJoin?: boolean})?.fromJoin;

  const clearTimer = () => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = undefined;
    }
  };

  useEffect(() => {
    setRemainTime(5);

    timer.current = setInterval(() => {
      setRemainTime((prev) => prev - 1);
    }, 1000);

    return () => {
      clearTimer();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (remainTime === 0) {
      clearTimer();
      navigate({pathname: paths.home}, {replace: true});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remainTime]);

  if (isPending || isRefetching || (fromJoin && !hasSession)) {
    return <Splash />;
  } else if (!hasSession) {
    return (
      <Navigate
        to={{pathname: paths.signin}}
        state={{from: {pathname, search}}}
      />
    );
  }

  return (
    <HorizontalFullContainer>
      <NavBar logoOnly />
      <Body>
        <FormWrapper>
          <Title style={{textAlign: 'center'}}>
            <span>
              마이프차 지도
              <br />
              가입을 환영합니다
            </span>
            <Typography
              variant="medium12"
              lineHeight="20px"
              color={palette.gray600}
              fontWeight="400"
            >
              {remainTime}초 후 홈화면으로 이동합니다
            </Typography>
          </Title>
          <img src={DoneImage} width="100%" alt="재설정 완료" />
          <FlexFullGrow />
          <NavLink
            to={{pathname: paths.pricing_root}}
            style={{display: 'inline-block', width: '100%'}}
          >
            <Button variant="fill" color="primary" size="mediumLarge" fullWidth>
              요금제 보러 가기
            </Button>
          </NavLink>
        </FormWrapper>
      </Body>
    </HorizontalFullContainer>
  );
};

export default Welcome;

const FormWrapper = styled(FormWrapperBase)`
  padding: 24px 26px 40px;
  align-items: center;
  gap: 20px;
`;

const Title = styled(TitleBase)`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
